import { FunctionsHttpError } from "@supabase/supabase-js";

/**
 * supabase-js's `error.message` for a non-2xx Edge Function response is
 * always the generic "Edge Function returned a non-2xx status code" — the
 * function's own JSON body (e.g. `{"error": "An account with that email
 * already exists."}`) only lives on `error.context`, a Response the caller
 * has to read itself (per the supabase-js docs' own example). Without this,
 * every real reason a form submission failed — a validation message, a
 * duplicate-email conflict, a server misconfiguration — was hidden behind
 * that one unhelpful string on every lead, order and Trident form on this
 * site. Use this wherever a `supabase.functions.invoke()` error is shown
 * to a user, before falling back to a generic message.
 */
export async function extractFunctionErrorMessage(error: unknown): Promise<string | null> {
  if (!(error instanceof FunctionsHttpError)) return null;
  try {
    const body = await error.context.json();
    return typeof body?.error === "string" ? body.error : null;
  } catch {
    return null;
  }
}
